<template>
  <svgIcon class="size"/>
</template>

<script>
import { defineComponent, reactive, computed } from 'vue'
import svgIcon from '@/assets/svg/ic_true.svg'

export default defineComponent({
  props: {
  },
  components: {
    svgIcon
  },
  setup (props, context) {
  }
})
</script>

<style lang="scss" scoped>
.size {
  width: 1em;
  height: 1em;
}
.lg{
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
